import { Card, TabPanel, TabView } from '@agro1desenvolvimento/react-components';
import { useHistory, useLocation } from 'react-router-dom';
import { TetrazolioHookData } from '../../../hooks/useTetrazolio';
import { CanteiroAreiaHookData } from '../../../hooks/useCanteiroAreia';
import ListaSementesHeader from './ListaSementesHeader';
import ListaTetrazolio from './ListaTetrazolio/ListaTetrazolio';
import ListaCanteiroAreia from './ListaCanteiroAreia/ListaCanteiroAreia';

interface Props {
  tetrazolioData: TetrazolioHookData;
  canteiroAreiaData: CanteiroAreiaHookData;
}

export default function ListaSementesTabs({ tetrazolioData, canteiroAreiaData }: Props) {
  const history = useHistory();
  const location = useLocation();

  const getActiveTabIndex = () => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    return tab === 'canteiro-areia' ? 1 : 0;
  };

  const handleTabChange = (e: any) => {
    const tabIndex = e.index;
    const searchParams = new URLSearchParams(location.search);

    if (tabIndex === 1) {
      searchParams.set('tab', 'canteiro-areia');
    } else {
      searchParams.delete('tab');
    }

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return (
    <TabView
      activeIndex={getActiveTabIndex()}
      onTabChange={handleTabChange}
    >
      <TabPanel header="Tetrazólio">
        <Card className="tetrazolio">
          <ListaSementesHeader data={tetrazolioData} />
          <ListaTetrazolio
            items={tetrazolioData.data}
            loading={tetrazolioData.loading}
            error={tetrazolioData.error}
            meta={tetrazolioData.meta}
            onPageChange={tetrazolioData.changePage}
          />
        </Card>
      </TabPanel>
      <TabPanel header="Canteiro de Areia">
        <Card className="canteiro-areia">
          <ListaSementesHeader data={canteiroAreiaData} />
          <ListaCanteiroAreia
            items={canteiroAreiaData.data}
            loading={canteiroAreiaData.loading}
            error={canteiroAreiaData.error}
            meta={canteiroAreiaData.meta}
            onPageChange={canteiroAreiaData.changePage}
          />
        </Card>
      </TabPanel>
    </TabView>
  );
}
